<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Rutas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">Básico</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Rutas</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ id ? "Editar" : "Crear" }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-6 pt-2 pb-2">
                <h5 class="mb-0">
                  Formulario {{ id ? "Editar" : "Crear" }} Rutas
                </h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Sitios"
                    v-if="id != null"
                    >Sitios y Puntos de Gestión</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Rutas"
                    v-if="id != null && $store.getters.can('admin.rutas.edit')"
                    >Ruta</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Geocercas"
                    v-if="id != null"
                    >Geocercas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="form-group col-md-4">
                        <label>Nombre Ruta:</label>
                        <input
                          type="text"
                          maxlength="100"
                          class="form-control form-control-sm"
                          v-model="form.nombre"
                          :class="
                            $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Origen:</label>
                        <v-select
                          v-model="form.origen_id"
                          class="form-control form-control-sm p-0"
                          label="nombre"
                          :class="[
                            $v.form.origen_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          :options="listasForms.origenes"
                          :reduce="(o) => o.id"
                          @input="validarRuta()"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Destino:</label>
                        <v-select
                          :class="[
                            $v.form.destino_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="form.destino_id"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.destinos"
                          :reduce="(d) => d.id"
                          @input="validarRuta()"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-2">
                        <label>Código:</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.codigo"
                          :class="
                            $v.form.codigo.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Horas Vigencia:</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          id="horas_vigencia"
                          v-model="form.horas_vigencia"
                          :class="
                            $v.form.horas_vigencia.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label>Tipo de Ruta:</label>
                        <v-select
                          v-model="form.tipo_ruta"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $v.form.tipo_ruta.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          label="descripcion"
                          :options="listasForms.tipoRutas"
                          :reduce="(tr) => tr.numeracion"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-3">
                        <label>Tipo Despachado:</label>
                        <v-select
                          v-model="form.tipo_despachado"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $v.form.tipo_despachado.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          label="descripcion"
                          :options="listasForms.tiposDespachados"
                          :reduce="(tr) => tr.numeracion"
                          @input="form.rutas_despachados = []"
                        >
                        </v-select>
                      </div>
                      <div
                        v-if="form.tipo_despachado"
                        class="form-group"
                        :class="
                          form.tipo_despachado == 1 ? 'col-md-5' : 'col-md-11'
                        "
                      >
                        <label>Despachado a:</label>
                        <v-select
                          :class="[
                            $v.form.rutas_despachados.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="form.rutas_despachados"
                          label="descripcion"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.despachados"
                          :multiple="form.tipo_despachado == 2"
                        >
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="Sitios">
                  <div class="card-body">
                    <RutaSitio v-if="id != null"></RutaSitio>
                  </div>
                </div>
                <div class="tab-pane fade" id="Rutas">
                  <div class="card-body">
                    <RutaDetalle ref="RutaDetalle"></RutaDetalle>
                  </div>
                  <!-- <div class="card-body">
                    <RutaPolilineas v-if="id != null"></RutaPolilineas>
                  </div> -->
                </div>
                <div class="tab-pane fade" id="Geocercas">
                  <div class="card-body">
                    <RutaGeocerca v-if="id != null"></RutaGeocerca>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                  <button
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    @click="save()"
                    v-if="
                      $store.getters.can('admin.rutas.create') ||
                        $store.getters.can('admin.rutas.edit')
                    "
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../../../components/Loading";
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import RutaSitio from "./RutaSitio";
import RutaDetalle from "./RutaDetalle";
import RutaGeocerca from "./RutaGeocerca";
// import RutaPolilineas from "./RutaPolilineas";
const google = window.google;

export default {
  name: "RutaForm",
  components: {
    Loading,
    vSelect,
    RutaSitio,
    RutaDetalle,
    RutaGeocerca,
    // RutaPolilineas,
  },

  data() {
    return {
      cargando: false,
      id: null,
      ruta: {},
      origen_form: null,
      destino_form: null,
      filtros:{},
      form: {
        nombre: null,
        origen_id: null,
        destino_id: null,
        horas_vigencia: null,
        tipo_ruta: null,
        tipo_despachado: null,
        rutas_despachados: null,
        redireccionamiento: false,
      },
      listasForms: {
        tipoRutas: [],
        origenes: [],
        destinos: [],
        despachados: [],
        estados: [],
        tiposDespachados: [
          { numeracion: 1, descripcion: "ÚNICO DESPACHADO" },
          { numeracion: 2, descripcion: "MULTIDESPACHADO" },
        ],
      },
      polilinea_ruta: [],
      ver_form_ruta: false,
    };
  },

  validations: {
    form: {
      nombre: {
        required,
      },
      origen_id: {
        required,
      },
      destino_id: {
        required,
      },
      codigo: {
        required,
      },
      horas_vigencia: {
        required,
      },
      tipo_ruta: {
        required,
      },
      tipo_despachado: {
        required,
      },
      rutas_despachados: {
        required,
      },
    },
  },

  methods: {
    getIndex() {
      if (this.$route.params.filtros){
        this.filtros = this.$route.params.filtros;
      }
      if (this.$route.params.id) {
        this.cargando = true;
        this.id = this.$route.params.id;
        axios
          .get("/api/admin/rutas/getRuta/" + this.id)
          .then((response) => {
            this.cargando = false;
            this.form = response.data;
            this.ruta = response.data; // Aquí cargas la información de la ruta

            if (this.form.despachado_a_id) {
              this.form.rutas_despachados = this.listasForms.despachados.find(
                (d) => d.numeracion === this.form.despachado_a_id
              );
            }

            // Asignar datos de origen y destino
            this.origen_form = this.form.origen_id;
            this.destino_form = this.form.destino_id;

            if (this.id && this.$refs.RutaDetalle) {
              this.$refs.RutaDetalle.getIndex();
            }
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    getDespachados() {
      axios.get("/api/lista/54").then((response) => {
        this.listasForms.despachados = response.data;
      });
    },
    getListaSitio() {
      axios.get("/api/lista/18").then((response) => {
        this.listasForms.listaSitios = response.data;
      });
    },
    getTipoRutas() {
      axios.get("/api/lista/48").then((response) => {
        this.listasForms.tipoRutas = response.data;
      });
    },
    showDespachado() {
      axios
        .get("/api/admin/rutas/despachados/" + this.$route.params.data_edit.id)
        .then((response) => {
          this.despachados = response.data.rutas_despachados;
        });
    },
    getOrigenes() {
      axios
        .get("api/admin/sitios/lista")
        .then((response) => {
          this.listasForms.origenes = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    validarRuta() {
      this.polilinea_ruta = [];
      if (this.form.origen_id && this.form.destino_id) {
        if (this.form.origen_id == this.form.destino_id) {
          this.form.destino_id = null;
          this.destino = null;
          this.$swal({
            icon: "error",
            title: `El Origen y Destino de la ruta no puede ser el mismo...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return;
        }
      }
    },
    getDestinos() {
      axios
        .get("api/admin/sitios/lista")
        .then((response) => {
          this.listasForms.destinos = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    save() {
      if (!this.$v.form.$invalid) {
        if (
          this.id &&
          (this.origen_form != this.form.origen_id ||
            this.destino_form != this.form.destino_id ||
            this.polilinea_ruta.length > 0)
        ) {
          this.$swal({
            title: "Está seguro de editar esta ruta?",
            text:
              "Se ha modificado el origen o el destino de esta ruta!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, Modificar!",
          }).then((result) => {
            if (result.value) {
              this.guardar();
            }
          });
          return false;
        }
        this.guardar();
      }
    },
    guardar() {
      this.form.path =
        this.polilinea_ruta.length > 0 ? this.polilinea_ruta : null;
      if (Array.isArray(this.form.rutas_despachados)) {
        this.form.despachado_a_id = null;
        this.form.despachados = this.form.rutas_despachados.map(
          (d) => d.numeracion
        );
      } else if (this.form.rutas_despachados) {
        this.form.despachado_a_id = this.form.rutas_despachados.numeracion;
        this.form.despachados = null;
      }
      this.cargando = true;
      axios({
        method: this.id ? "PUT" : "POST",
        url: "/api/admin/rutas",
        data: this.form,
      })
        .then((response) => {
          this.cargando = false;
          if (response.data.status == 0) {
            this.$swal({
              icon: "error",
              title: response.data.msg,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$route.params.id = response.data.id;
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "La Ruta se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    back() {
      return this.$router.replace({
        name:"/Admin/Rutas",
        params: {filtros: this.filtros },
      });
    },
  },

  beforeMount() {
    this.getListaSitio();
    this.getTipoRutas();
    this.getDespachados();
    this.getDestinos();
    this.getOrigenes();
  },

  mounted() {
    this.getIndex();
    this.$nextTick(() => {
      const tabRuta = document.querySelector('#myTab a[href="#Rutas"]');
      if (tabRuta) {
        tabRuta.addEventListener("shown.bs.tab", () => {
          const detalle = this.$refs.RutaDetalle;
          if (detalle && detalle.viewMap.geocercas) {
            detalle.cargarGeocercasMapa();
          }
        });
      }
    });
  },
};
</script>
